import "./melaTable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  CircularProgress, // Import loading indicator
} from "@mui/material";
import { Add, Edit, Delete } from "@mui/icons-material";
import { useSelector } from "react-redux";

const MelaTable = () => {
  let userId = useSelector((state) => state.user.userId);
  const adminType = useSelector((state) => state.user.adminType);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  // States
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedMela, setSelectedMela] = useState(null);

  if (adminType === "sAdmin") {
    userId = "1";
  }

  // Fetch all Mela
  useEffect(() => {
    const fetchMela = async () => {
      setLoading(true); // Set loading state to true before fetching
      try {
        const res = await axios.get(
          `${BASE_URL}/api/mela/findAllMelaName/${userId}`
        );
        setData(res.data);
      } catch (err) {
        console.error("Error fetching Mela:", err);
      }
      setLoading(false); // Set loading state to false after data is fetched
    };
    fetchMela();
  }, [userId, BASE_URL]);

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/api/mela/deleteMelaName/${id}`
      );
      if (response.status === 200) {
        setData(data.filter((item) => item._id !== id));
      }
    } catch (err) {
      console.error("Error deleting Mela:", err);
    }
  };

  const handleUpdate = (melaData) => {
    navigate("/mela/newMela", { state: { mela: melaData } }); // Pass user data to Mela
  };

  const melaListColumns = [
    { field: "_id", headerName: "ID", width: 70 },
    {
      field: "melaName",
      headerName: "Mela Name",
      width: 500,
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      width: 220,
    },
  ];

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <IconButton color="primary" aria-label="addButton">
              <Link to="/mela/newMela">
                <Add />
              </Link>
            </IconButton>

            <IconButton
              onClick={() => {
                setSelectedMela(params.row);
                setOpenDialog(true);
              }}
              color="error"
              aria-label="delete"
            >
              <Delete />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedMela(null);
  };

  const handleConfirmDelete = async () => {
    if (selectedMela) {
      await handleDelete(selectedMela._id);
      setOpenDialog(false);
    }
  };

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <Typography variant="h5" gutterBottom>
          List Of Mela
        </Typography>
        <Link to="/mela/newMela">
          <Button variant="contained" color="primary">
            Add Mela
          </Button>
        </Link>
      </div>
      <Grid container justifyContent="center">
        {loading ? ( // Show loading indicator while fetching
          <CircularProgress size={50} />
        ) : (
          <DataGrid
            className="datagrid"
            rows={data}
            columns={melaListColumns.concat(actionColumn)}
            pageSize={5}
            rowsPerPageOptions={[5]}
            checkboxSelection
            getRowId={(row) => row._id}
          />
        )}
      </Grid>

      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this Mela?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MelaTable;
